import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { State } from '../../../model/types.tsx';
import {
	getProjectKey,
	isProjectAdmin,
	isProjectSimplified,
} from '../../../state/selector/app-props/index.tsx';
import { getServiceDeskEmail, isEmailEnabled } from '../../../state/selector/app-state/index.tsx';
import { EmailChannelView } from './view.tsx';

const mapStateToProps = (state: State) => ({
	isAdmin: isProjectAdmin(state),
	isEnabled: isEmailEnabled(state),
	isProjectSimplified: isProjectSimplified(state),
	email: getServiceDeskEmail(state),
	projectKey: getProjectKey(state),
	baseUrl: '',
});

export const EmailChannel = connect(mapStateToProps, {})(EmailChannelView);
